import './responsive.css'

export default function Responsive (){
    return (
        <>
        </>
    )
}
